export default function init(element) {
    const menuMobile = document.querySelector('.js-menu-mobile');
    const burgerInactive = document.querySelector('.js-burger-inactive');
    const burgerActive = document.querySelector('.js-burger-active');
    const triggers = document.querySelectorAll('.js-menu-mobile-trigger');

    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
            if (trigger.classList.contains('js-burger-inactive')) {
                burgerActive.querySelector('input').checked = true;
            } else {
                burgerInactive.querySelector('input').checked = false;
            }
            menuMobile.classList.toggle('!right-0');
        });
    });
}